<script>
import CloseConversation from "@/EventLogic/components/actions/CloseConversation.vue";

export default {
  extends: CloseConversation,
  props: {
    id: String,
    conversationId: String,
  },
  computed: {
    filteredConversations() {
      return this.config.studyConversations
          .filter(source => source.class === 'TextConversationConnector');
    },
  }
}

</script>